import React,{useState} from 'react';
import '../geststs.css';

function Geststs() {
  const [geretoken,setGerar]=useState(null);
  const [valor,setValor]=useState({contador:"",valor:"",unidade:"Mzn"});
  const[detalhes,setDetalhes]=useState({contador:""});
  const [tokenGerado,setTokenGerado]=useState(null);
  const [tokenGeradotip,setTokenGeradotip]=useState(null);
  const [gestao,setGestaoM]=useState(null);
  const [kmc,setKmc]=useState(null);
  const [smk,setSmk]=useState(null);
  const [geretokenf,setGeretokenf]=useState(null);
  const [aa,setAD]=useState(null);
  const [DITK,setDITK]=useState(null);
  const [SGC,setSGC]=useState(null);
  const [trans,setTrans]=useState(null);
  const [transc,setTransc]=useState(null);
  
  const HToken=(e)=>{
      e.preventDefault();
      setTokenGeradotip(null);
      setTokenGerado(null);
      setSmk(null);
      setTransc(null);
      setTrans(null);
      setKmc(null);
      setGerar(null);
      setGestaoM(null);
      setGeretokenf(null)
      setGerar('dfdf');    
  }
  const HsToken=(e)=>{
    e.preventDefault();
    setTokenGeradotip(null);
    setTokenGerado(null);
    setSmk(null);
    setKmc(null);
    setGerar(null);
    setGestaoM(null);
    setTransc(null);
    setGeretokenf(null)
    setGerar(null);    
    setTrans('dfd')
  }
  const DHToken=(e)=>{
    e.preventDefault();
      setTokenGerado(null);
      setTokenGeradotip(null);
      setKmc(null);
      setSmk(null);
      setTrans(null)
      setTransc(null);
      setGerar(null);
      setGerar(null);    
      setGestaoM(null);
      setGeretokenf('sdsd');
  }
  const SMGHandler=(e)=>{
      e.preventDefault();
      setTokenGerado(null);
      setGerar(null);
      setTrans(null)
      setTransc(null);
      setSmk(null);
 setKmc(null);
 setTokenGeradotip(null);
      setGerar(null);    
      setGeretokenf(null);
      setTrans(null)
      setTransc(null);
      setGestaoM('dfdf');
  }
  const KMCHANDLER=(e)=>{
    e.preventDefault();
      setTokenGerado(null);
      setGerar(null);
      setGerar(null);    
      setTrans(null);
      setTransc(null);
      setGeretokenf(null);
      setGestaoM(null);
      setKmc('sdsd');
      setSmk(null);
      setTokenGeradotip(null);
    }
  const SMKHandler=(e)=>{
    e.preventDefault();
    setTokenGerado(null);
    setTrans(null)
     setGerar(null);
    setGerar(null);    
    setGeretokenf(null); setTokenGeradotip(null);
    setGestaoM(null);
    setTransc(null);
    setKmc(null);
    setSmk('dfdf');
  }
  const AAToken=(e)=>{
    e.preventDefault()
    setTrans(null)  
    setTransc(null);
    setDITK(null);
    setSGC(null);
    setAD('sdsd'); setTokenGeradotip(null);
  }
  const DITKHToken=(e)=>{
    e.preventDefault()
    setAD(null);
    setTrans(null)
    setTransc(null);
    setSGC(null);
    setDITK('sdsd');
     setTokenGeradotip(null);
  }
  const SGCHandler=(e)=>{
      e.preventDefault()
      setAD(null);
      setTrans(null)
      setDITK(null);
      setSGC('sdsds');
      setTokenGeradotip(null);
      setTransc(null);
  }
  return (
    <div><div className='Filtro'>
    <button  id="opcao" value="Nao" onClick={HToken} >Recarga Teste </button>
    <button  id="opcao" value="Nao  "onClick={HsToken} >Transferir Saldo</button>
    <button  id="opcao" value="Nao"  onClick={DHToken} >Token debuger</button>
    <button  id="opcao" value="Nao"  onClick={HToken} >Tokens de Reposicao de Violacao </button>  
    <button  id="opcao" value="Nao"  onClick={HToken}>Limpar Credito</button>  
    <button  id="opcao" value="Nao"  onClick={SMGHandler}>Gestao do Modulo de Seguranca</button>  
    <button  id="opcao" value="Nao"  onClick={KMCHANDLER}>KMF</button>  
    <button  id="opcao" value="Nao"  onClick={SMKHandler}>STS METER KEY MANAGEMENT</button>  
   
    </div>
   {geretoken &&   <div className="procurar_iunf">
            
            <label for="name">
                <span>Numero de Contador</span>
            </label>
         
           <input type="text" id="ipesqui" name="name" autoComplete='off' maxLength={13} onChange={e=> setDetalhes({...detalhes,contador:e.target.value}) } value={detalhes.contador} required/>
            <input type="submit" id="pesqui" onClick={()=>{setTokenGerado('sds')}} value="Gerar"/>
                
            </div>

   }
   {trans && <div className="procurar_iunf">
            
            <label for="name">
                <span>Numero de Contador</span>
            </label>
         
           <input type="text" id="ipesqui" name="name" autoComplete='off' maxLength={13} onChange={e=> setDetalhes({...detalhes,contador:e.target.value}) } value={detalhes.contador} required/>
            <input type="submit" id="pesqui" onClick={()=>{setTransc('sds')}} value="Gerar"/>
                
            </div>
}
   {smk && <div>
    <div className='Filtro'>
    <button  id="opcao" value="Nao" onClick={AAToken} >Add or Delete VUDK/VDDK</button>
    <button  id="opcao" value="Nao"  onClick={DITKHToken} >DITK gestao</button>
    <button  id="opcao" value="Nao"  onClick={SGCHandler} >Replace SGC</button>  
        {SGC && <div className='sdsdaca'>
            <div>
            <label for="name">
                <span>Meter NUM</span>
            </label>
        
            <input type="text" id="ipesquia" name="name" autoComplete='off' maxLength={13} required/>
            <input type="submit" id="pesqui" onClick={()=>{setTokenGerado('sd')}} value="actualizar"/>
         </div>
            <div>FROM SGC:<select id="combo" onChange={(e)=>{
                            const provincia=e.target.value;
                        }}>
         
                        
                            <option value="">NENHUM</option>
                            
                        </select></div>
            <div>TO SGC:<select id="combo" onChange={(e)=>{
                            const provincia=e.target.value;
                        }}>
         
                        
                            <option value="">NENHUM</option>
                           
                        </select></div>
                     
            </div>}
        {DITK && <div>
            <div id='table_holder'>
            <table>
            <thead>
            <tr>
            <th>KMF ID</th>
            <th>KMF Name</th>
            <th>Data de Registro</th>
            
            </tr>
            </thead>
    
        <tbody> <tr> 
        
        </tr>
   
   
      </tbody>  
            </table>
          
            </div>
            <div className='Filtro'>  <button  id="opcao" value="Nao" >ADD</button>  
           <button  id="opcao" value="Nao"  >Delete</button>  
          </div>
            
            </div>}
        {aa && <div>
            <div id='table_holder'>
            <table>
            <thead>
            <tr>
            <th>KMF ID</th>
            <th>KMF Name</th>
            <th>Data de Registro</th>
            
            </tr>
            </thead>
    
        <tbody> <tr> 
        
        </tr>
   
   
      </tbody>  
            </table>
          
            </div>
            <div className='Filtro'>  <button  id="opcao" value="Nao" >ADD</button>  
           <button  id="opcao" value="Nao"  >Delete</button>  
          </div>
          <label for="name">
                <span>DITK</span>
            </label>
        
            <input type="text" id="ipesquiasa" name="name" autoComplete='off' maxLength={13} required/>
            <input type="submit" id="pesquia"  value="actualizar"/>
            
            
            </div>}
    </div>
       
       </div>}
   {kmc &&  <div className='Token_gerado'>
   <div id='table_holder'>
            <table>
            <thead>
            <tr>
            <th>KMF ID</th>
            <th>KMF Name</th>
            <th>Data de Registro</th>
            
            </tr>
            </thead>
    
        <tbody> <tr> 
        <td>1</td>
        <td>SM+Prism+94001014.kmf</td>
        <td>{new Date().toISOString()}</td>
        
        </tr>
   
   
      </tbody>  
            </table>
          
            </div>
            <div className='Filtro'>  <button  id="opcao" value="Nao" >Refresh</button>  
           <button  id="opcao" value="Nao"  >Delete</button>  
          </div>
          
       </div>}
   {geretokenf &&   <div className="procurar_iunf">
            
            <label for="name">
                <span>Numero da Recarga</span>
            </label>
        
            <input type="text" id="ipesqui" name="name" autoComplete='off' maxLength={20} onChange={e=> setDetalhes({...detalhes,contador:e.target.value}) } value={detalhes.contador} required/>
            <input type="submit" id="pesqui" onClick={()=>{setTokenGeradotip('sds')}} value="Gerar"/>
                
            </div>

   }
   {gestao && <div className='Token_gerado'>
   <div id='table_holder'>
            <table>
            <thead>
            <tr>
            <th>Device ID</th>
            <th>Tipo de Modulo de Seguranca</th>
            <th>tempo de registro</th>
            <th>communication parameters</th>
            <th>Estado</th>
            
            </tr>
            </thead>
    
        <tbody> <tr> 
        <td>1</td>
        <td>PrismToken</td>
        <td>{new Date().toISOString()}</td>
        <td>IP:123.334.12.1</td>
        <td>Online</td>
       
        </tr>
   
   
      </tbody>  
            </table>
          
            </div>
            <div className='Filtro'>  <button  id="opcao" value="Nao" >Refresh</button>  
           <button  id="opcao" value="Nao"  >Disconnect</button>  
          </div>
          
       </div>}
   {tokenGeradotip && 
            <div className='Token_gerado'>
            <h1> Valido</h1>
        </div>

   }
   {tokenGerado &&
            <div className='Token_gerado'>
                <h1> 1234 6743 9871 1234 2345</h1>
            
                
            </div>

   }
  {transc &&
            <div className='Token_gerado'>
                <h4>Contador de Origem</h4>
                <h1> 1234 6743 9871 1234 2345</h1>
                <h4>Contador de Destino</h4>
               
                <h1> 1234 6743 9871 1234 2345</h1>
            
                
            </div>

   }
    </div>
  )
}

export default Geststs